
import { 
    getUtil, 
    postUtil, 
    deleteUtil, 
    // putUtil 
} from "../../services/axiosClient";
import { API } from "../../utils/Constant";
import { put, takeLatest, } from "redux-saga/effects";
import {
    CREATE_ALLOCATOR_NETWORKS,
    CREATE_ALLOCATOR_NETWORKS_FAILED,
    CREATE_ALLOCATOR_NETWORKS_INIT,
    CREATE_ALLOCATOR_NETWORKS_SUCCESS,
    DELETE_ALLOCATOR_NETWORKS,
    DELETE_ALLOCATOR_NETWORKS_FAILED,
    DELETE_ALLOCATOR_NETWORKS_INIT,
    DELETE_ALLOCATOR_NETWORKS_SUCCESS,
    GET_ALLOCATOR_CONTACTS,
    GET_ALLOCATOR_CONTACTS_FAILED,
    GET_ALLOCATOR_CONTACTS_INIT,
    GET_ALLOCATOR_CONTACTS_SUCCESS,
    GET_ALLOCATOR_USERS,
    GET_ALLOCATOR_USERS_FAILED,
    GET_ALLOCATOR_USERS_INIT,
    GET_ALLOCATOR_USERS_SUCCESS,
    IMPORT_ALLOCATOR_CONTACT,
    IMPORT_ALLOCATOR_CONTACT_FAILED,
    IMPORT_ALLOCATOR_CONTACT_INIT,
    IMPORT_ALLOCATOR_CONTACT_SUCCESS,
    SEND_ALLOCATOR_INVITATION_EMAIL,
    SEND_ALLOCATOR_INVITATION_EMAIL_FAILED,
    SEND_ALLOCATOR_INVITATION_EMAIL_INIT,
    SEND_ALLOCATOR_INVITATION_EMAIL_SUCCESS,
    UPDATE_ALLOCATOR_NETWORKS,
    UPDATE_ALLOCATOR_NETWORKS_FAILED,
    UPDATE_ALLOCATOR_NETWORKS_INIT,
    UPDATE_ALLOCATOR_NETWORKS_SUCCESS,
} from "./constants";
import GenerateUrl from "@hedgefund/shared/src/GenerateUrl";

const getContactParams = [
    { keyword: "Keyword", value: "keyword" },
    { keyword: "page", value: "page" },
    { keyword: "perPage", value: "perPage" },
    { keyword: "sortBy", value: "sortBy" },
    { keyword: "sortByColumn", value: "sortByColumn" },
];
export function* getAllocatorUsers({ payload }) {
    try {
        yield put({ type: GET_ALLOCATOR_USERS_INIT });

        const res = yield getUtil(`${API.GetCompanyUsers}?id=${payload}`);
        if (res?.status === 200) {
            const { data } = res;

            yield put({
                type: GET_ALLOCATOR_USERS_SUCCESS,
                payload: data.result,
            });
        } else {
            yield put({ type: GET_ALLOCATOR_USERS_FAILED });
        }
    } catch (error) {
        throw new Error(error);
    }
}
export function* getAllocatorContacts({ payload }) {
    try {
        yield put({ type: GET_ALLOCATOR_CONTACTS_INIT });

        let url = API.GetAllocatorContact + GenerateUrl(payload, getContactParams);

        const res = yield getUtil(url);
        if (res?.status === 200) {
            const { data } = res;

            yield put({
                type: GET_ALLOCATOR_CONTACTS_SUCCESS,
                payload: data.result,
            });
        } else {
            yield put({ type: GET_ALLOCATOR_CONTACTS_FAILED });
        }
    } catch (error) {
        throw new Error(error);
    }
}

export function* importAllocatorContacts({ payload, onSuccess }) {
    try {
        yield put({ type: IMPORT_ALLOCATOR_CONTACT_INIT });

        const res = yield postUtil(API.ImportAllocatorContact, payload);
        if (res?.status === 200) {
            onSuccess();
            const { data } = res;
            yield put({
                type: IMPORT_ALLOCATOR_CONTACT_SUCCESS,
                payload: data.result,
            });
        } else {
            yield put({ type: IMPORT_ALLOCATOR_CONTACT_FAILED });
        }
    } catch (error) {
        throw new Error(error);
    }
}

export function* sendInvitationEmailSaga({ payload, onSuccess }) {
    try {
        yield put({ type: SEND_ALLOCATOR_INVITATION_EMAIL_INIT });

        const res = yield getUtil(`${API.SendInvitationEmail}?id=${payload}`);
        if (res?.status === 200) {
            onSuccess();
            yield put({
                type: SEND_ALLOCATOR_INVITATION_EMAIL_SUCCESS,
            });
        } else {
            yield put({ type: SEND_ALLOCATOR_INVITATION_EMAIL_FAILED });
        }
    } catch (error) {
        throw new Error(error);
    }
}

export function* createAllocatorNetwork({ payload }) {
    try {
        yield put({ type: CREATE_ALLOCATOR_NETWORKS_INIT });

        const res = yield postUtil(API.CreateConnection, payload);
        if (res?.status === 200) {
            const { data } = res;

            yield put({
                type: CREATE_ALLOCATOR_NETWORKS_SUCCESS,
                payload: data.result,
            });
        } else {
            yield put({ type: CREATE_ALLOCATOR_NETWORKS_FAILED });
        }
    } catch (error) {
        throw new Error(error);
    }
}


export function* updateAllocatorNetwork({ payload }) {
    try {
        yield put({ type: UPDATE_ALLOCATOR_NETWORKS_INIT });

        const res = yield postUtil(API.UpdateConnection, payload);
        if (res?.status === 200) {
            const { data } = res;

            yield put({
                type: UPDATE_ALLOCATOR_NETWORKS_SUCCESS,
                payload: data.result,
            });
        } else {
            yield put({ type: UPDATE_ALLOCATOR_NETWORKS_FAILED });
        }
    } catch (error) {
        throw new Error(error);
    }
}

export function* deleteAllocatorNetwork({ payload }) {
    try {
        yield put({ type: DELETE_ALLOCATOR_NETWORKS_INIT });

        const res = yield deleteUtil(`${API.DeleteConnection}?id=${payload}`);
        if (res?.status === 200) {
            const { data } = res;

            yield put({
                type: DELETE_ALLOCATOR_NETWORKS_SUCCESS,
                payload: data.result,
            });
        } else {
            yield put({ type: DELETE_ALLOCATOR_NETWORKS_FAILED });
        }
    } catch (error) {
        throw new Error(error);
    }
}

export function* AllocatorContactSaga() {
    yield takeLatest(GET_ALLOCATOR_USERS, getAllocatorUsers);
    yield takeLatest(GET_ALLOCATOR_CONTACTS, getAllocatorContacts);
    yield takeLatest(IMPORT_ALLOCATOR_CONTACT, importAllocatorContacts);
    yield takeLatest(SEND_ALLOCATOR_INVITATION_EMAIL, sendInvitationEmailSaga);
    yield takeLatest(CREATE_ALLOCATOR_NETWORKS, createAllocatorNetwork);
    yield takeLatest(UPDATE_ALLOCATOR_NETWORKS, updateAllocatorNetwork);
    yield takeLatest(DELETE_ALLOCATOR_NETWORKS, deleteAllocatorNetwork);
}
